export default "__VITE_ASSET__20c97962__"